<form [formGroup]='chooseServicesForm' id='{{formGroupName}}' (ngSubmit)='onSubmit()'>
	
	<div class='step-title service-title' i18n>Recommended: Services you may also need</div>

	<div class='services-list'>
		<div class='service-item' *ngIf='formService.questions.includes("currency_exchange")' [class.service-item-selected]='chooseServicesForm.get("currency_exchange_selected")?.value' (click)='chooseServicesForm.get("currency_exchange_selected")?.setValue(!chooseServicesForm.get("currency_exchange_selected")?.value)'>
			<mat-checkbox formControlName='currency_exchange_selected' class='hidden-checkbox'>
				Currency Exchange
			</mat-checkbox>
			
			<div class="item-image">
				<mat-icon svgIcon='images:tp-currency-exchange'></mat-icon>
			</div>

			<div class="item-content">
				<div class='item-label' i18n>Currency Exchange</div>
				<div class='item-description' i18n>Competitive Rates</div>
			</div>

			<div class="item-actions">
				<div class='custom-checkbox' [class.checked]='chooseServicesForm.get("currency_exchange_selected")?.value'></div>
			</div>
		</div>

		<div class='service-item' *ngIf='formService.questions.includes("health_insurance")' [class.service-item-selected]='chooseServicesForm.get("health_insurance_selected")?.value' (click)='chooseServicesForm.get("health_insurance_selected")?.setValue(!chooseServicesForm.get("health_insurance_selected")?.value)'>
			<mat-checkbox formControlName='health_insurance_selected' class='hidden-checkbox'>
				Health Insurance
			</mat-checkbox>
			
			<div class="item-image">
				<mat-icon svgIcon='images:tp-health-insurance'></mat-icon>
			</div>

			<div class="item-content">
				<div class='item-label' i18n>Health Insurance</div>
				<div class='item-description' i18n>Compare Plans</div>
			</div>

			<div class="item-actions">
				<div class='custom-checkbox' [class.checked]='chooseServicesForm.get("health_insurance_selected")?.value'></div>
			</div>
		</div>

		<div class='service-item' *ngIf='formService.questions.includes("real_estate")' [class.service-item-selected]='chooseServicesForm.get("real_estate_selected")?.value' (click)='chooseServicesForm.get("real_estate_selected")?.setValue(!chooseServicesForm.get("real_estate_selected")?.value)'>
			<mat-checkbox formControlName='real_estate_selected' class='hidden-checkbox'>
				Real Estate
			</mat-checkbox>
			
			<div class="item-image">
				<mat-icon svgIcon='images:tp-real-estate'></mat-icon>
			</div>

			<div class="item-content">
				<div class='item-label' i18n>Real Estate Consultation</div>
				<div class='item-description' i18n>Expert Assistance</div>
			</div>

			<div class="item-actions">
				<div class='custom-checkbox' [class.checked]='chooseServicesForm.get("real_estate_selected")?.value'></div>
			</div>
		</div>

		<div class='service-item' *ngIf='formService.questions.includes("utilities")' [class.service-item-selected]='chooseServicesForm.get("utilities_selected")?.value' (click)='chooseServicesForm.get("utilities_selected")?.setValue(!chooseServicesForm.get("utilities_selected")?.value)'>
			<mat-checkbox formControlName='utilities_selected' class='hidden-checkbox'>
				Utilities Setup
			</mat-checkbox>
			
			<div class="item-image">
				<mat-icon svgIcon='images:tp-utilities'></mat-icon>
			</div>

			<div class="item-content">
				<div class='item-label' i18n>Set up your Utilities</div>
				<div class='item-description' i18n>Save on bills</div>
			</div>

			<div class="item-actions">
				<div class='custom-checkbox' [class.checked]='chooseServicesForm.get("utilities_selected")?.value'></div>
			</div>
		</div>
	</div>

	<!-- Mobile Navigation Buttons -->
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='submit' type='submit'>
				<ng-container *ngIf='formService.isLastThirdPartyStep()' i18n='buttonSaveSelection'>Save</ng-container>
				<ng-container *ngIf='!formService.isLastThirdPartyStep()' i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>
</form>
